module.exports = __webpack_public_path__ + "img/img_t4@2x.045780a2.png";